import { OperationStatus } from '@/graphql/generated';

export const isOperationHidden = (value?: OperationStatus | null) => !!value && value === OperationStatus.Hidden;

export const isOperationVisible = (value?: OperationStatus | null) => !!value && value !== OperationStatus.Hidden;

export const isOperationEnabled = (value?: OperationStatus | null) => !!value && value === OperationStatus.Enabled;

export const isOperationDisabled = (value?: OperationStatus | null) => !!value && value === OperationStatus.Disabled;
